import React from 'react'

import {SkeletonLoader} from '@vio/atlas/src/components/designSystem/SkeletonLoader'

export const FacetPillSkeletonLoader = () => {
  return <SkeletonLoader width={100} marginBottom={0} marginTop={0} />
}
